<template>
  <i v-if="motivo" v-tooltip="motivo" class="iconoir-lock extras-mg-candado"></i>
</template>

<script>
/**
 * El candadito en el encabezado de una columna que tú no escribes, con el
 * porqué al pasar el ratón.
 *
 * El core ya pinta uno, pero dice solo "Los cambios en este campo están
 * restringidos." y la piel Monday lo esconde junto con el icono de tipo. Este
 * lo sustituye (ver el estilo): uno solo, con el motivo, en las dos pieles.
 */
import { permisosDe } from '@extras_mg/utils/roles'

const MOTIVOS = {
  ENCARGADO:
    'Solo los Miembros de la base o de la tabla y los admins escriben en esta columna.',
  ADMIN: 'Solo los admins escriben en esta columna.',
  NADIE: 'Columna bloqueada: nadie escribe en ella.',
}

export default {
  name: 'CandadoDeColumna',
  props: {
    workspace: { type: Object, default: null },
    database: { type: Object, default: null },
    table: { type: Object, default: null },
    view: { type: Object, default: null },
    field: { type: Object, required: true },
  },
  computed: {
    motivo() {
      const espacio = this.database?.workspace?.id
      if (!espacio) return null
      const p = permisosDe(this.$store, espacio, 'mg_permisos_de_campo')
      if (!(p?.no_escribe || []).includes(this.field.id)) return null
      return MOTIVOS[p.niveles?.[this.field.id]] || null
    },
  },
}
</script>

<style lang="scss">
.extras-mg-candado {
  font-size: 12px;
  margin-right: 4px;
  opacity: 0.6;
}

/* Un solo candado: el del core no dice por qué. */
.grid-view__description:has(.extras-mg-candado)
  .grid-view__description-extra-icon.iconoir-lock {
  display: none;
}

/* En la piel Monday las opciones de la columna solo salen al pasar el ratón;
   en una columna que no escribes se quedan a la vista para que se vea el
   candado. */
html[data-piel='monday']
  .grid-view__head
  .grid-view__description-options:has(.extras-mg-candado) {
  opacity: 1;
}
</style>
